import React from 'react';

const MessageSkeleton = () => {
    return (
        <div className="animate-pulse p-4 border-b border-gray-100 w-full">
            <div className="flex items-center space-x-3">
                {/* Avatar Skeleton */}
                <div className="w-12 h-12 bg-gray-200 rounded-full flex-shrink-0"></div>

                {/* Text Contnet Skeleton */}
                <div className="flex-1 min-w-0 space-y-2">
                    <div className="flex justify-between items-start">
                        {/* Username */}
                        <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                        {/* Time */}
                        <div className="h-3 bg-gray-100 rounded w-1/6"></div>
                    </div>
                    {/* Last Message */}
                    <div className="h-3 bg-gray-100 rounded w-3/4"></div>
                </div>
            </div>
        </div>
    );
};

export const ChatAreaSkeleton = () => {
    return (
        <div className="flex-1 flex flex-col h-full bg-gray-50">
            {/* Header Skeleton */}
            <div className="border-b bg-white p-4 flex items-center justify-between">
                <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
                    <div className="space-y-2">
                        <div className="w-32 h-4 bg-gray-200 rounded animate-pulse"></div>
                        <div className="w-20 h-3 bg-gray-100 rounded animate-pulse"></div>
                    </div>
                </div>
            </div>

            {/* Messages Skeleton */}
            <div className="flex-1 p-4 space-y-6">
                {[1, 2, 3].map((i) => (
                    <div key={i} className={`flex ${i % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
                        <div className={`max-w-xs lg:max-w-md p-4 rounded-lg ${i % 2 === 0 ? 'bg-blue-50' : 'bg-white'
                            }`}>
                            <div className="h-4 bg-gray-200 rounded w-48 mb-2 animate-pulse"></div>
                            <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MessageSkeleton;
